import { lt, showSuccessAlert } from '@mews/framework';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { OriginFormValues } from './types';

export const useUpdateOriginMutation = (reservationIds: string[]) =>
    useRepositoryMutation('reservations', 'updateOrigin', {
        transformParams: ({ origin }: OriginFormValues) => ({
            reservationIds,
            origin,
        }),
        onSuccess: () => showSuccessAlert({ description: lt('OriginChangedSuccessMessage') }),
    });
